export type BoardTransform = {
  x: number;
  y: number;
  scale: number;
};

export type DotPlaneBounds = {
  left: number;
  top: number;
  width: number;
  height: number;
};

export function constrainBoardTransform(
  transform: BoardTransform,
  viewport: { width: number; height: number },
  board: { width: number; height: number },
  fallback: BoardTransform,
): BoardTransform {
  const scale = Number.isFinite(transform.scale) && transform.scale > 0
    ? transform.scale
    : fallback.scale;
  return {
    scale,
    x: constrainAxis(transform.x, board.width * scale, viewport.width, fallback.x),
    y: constrainAxis(transform.y, board.height * scale, viewport.height, fallback.y),
  };
}

function constrainAxis(
  position: number,
  contentSize: number,
  viewportSize: number,
  fallbackPosition: number,
): number {
  if (!Number.isFinite(viewportSize) || viewportSize <= 0) return 0;
  if (!Number.isFinite(contentSize) || contentSize <= 0) return fallbackPosition;
  // Let the infinite dotted plane occupy as much as half of either viewport
  // axis while always retaining a useful portion of the board on screen.
  const overscroll = viewportSize * .5;
  const center = (viewportSize - contentSize) / 2;
  const minimum = Math.min(center, viewportSize - contentSize - overscroll);
  const maximum = Math.max(center, overscroll);
  const safePosition = Number.isFinite(position) ? position : fallbackPosition;
  return Math.min(maximum, Math.max(minimum, safePosition));
}
